import Accordion from './Accordion'

export { default as AccordionItem } from './AccordionItem'

export default Accordion
